import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {DemoPage} from './index.tsx';

export const DemoRoutes: RouteObject = {
  path: ROUTES.DEMO.path,
  element: <DemoPage />,
}